import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Footer = () => {
  const appConfig = useSelector((state) => state?.app?.appConfig);

  return (
    <footer
      className="text-white py-2 z-[100] fixed bottom-0 left-0 w-full"
      style={{ backgroundColor: "#131834", zIndex:999 }}
    >
      <div className="px-4 sm:px-2 lg:px-4">
        <div className="flex justify-start items-center">
          <div className="flex items-center justify-center">
            <Link className="logo d-flex align-items-center justify-content-center">
              <img src={appConfig?.companyLogo} alt="" className="headerLogo" />
            </Link>
          </div>

          <div className="text-sm ml-4">
            <p className="p-0 m-0 text-white">
              &copy; Copyright{" "}
              <span className="text-white">Aatral Technologies</span>. All Rights Reserved
            </p>
            <div className="text-gray-400 text-left">
              <span className="text-white pr-2">Designed by</span>
              <Link className="text-red-600 hover:text-blue-600 transition-colors">
                Aatral Technologies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
